<template>
  <b-modal size="xl" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <div>

      <b-button variant="primary" class="mt-3" @click="triggerFileInput">
        <b-icon icon="paperclip" font-scale="2" />
      </b-button>
      <b-form-file ref="fileInput" class="d-none" id="documentoInput"
        accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        @change="adicionarArquivo"></b-form-file>

      <b-table :items="files" :fields="fields" show-empty>

        <template #empty>
          <p>Nenhum registro encontrado</p>
        </template>


        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <template #cell(tipoDocumento)="data">
          <lg-form-select v-model="data.item.tipoDocumento" :loadFunction="listDocumentos" labelFormGroupBind="Tipo:"
            label="descricao" class="fix-dropdown-inside-table" invalidFeedback="O tipo deve ser informado!" description="" />
        </template>

        <template #cell(numero)="data">
          <lg-form-input v-model="data.item.numero" label="Numero Documento:" />
        </template>

        <template #cell(data)="data">
          <LgFormDate v-model="data.item.data" label="Data do Documento: *" />
        </template>

        <template #cell(localizacaoFisica)="data">
          <lg-form-input v-model="data.item.localizacaoFisica" label="Loc. Física:" />
        </template>

        <template #cell(actions)="data">
          <b-button variant="danger" @click="removeRow(data.index)">
            <b-icon icon="trash" />
          </b-button>
        </template>
      </b-table>

      <div class="d-flex justify-content-center mt-3">
        <b-button type="submit" variant="success" style="height: 30px" pill size="sm" @click="submitData">
          <div>
            <b-icon icon="check-circle" />
          </div>
        </b-button>
        <b-button class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
          <div>
            <b-icon icon="x-circle" />
          </div>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormDate from "../Form/LgFormDate.vue";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import API from "../../api";
import { dataURItoBlob } from "@/utils/FileConverter";
import moment from "moment";

export default {
  components: {
    LgFormInput,
    LgFormDate,
    LgFormSelect,
  },
  data() {
    return {
      files: [],
      showModal: true,
      fields: [
        { key: "name", label: "Nome" },
        { key: "tipoDocumento", label: "Tipo Documento", thStyle: { width: "30%" } },
        { key: "numero", label: "Nº Documento" },
        { key: "data", label: "Data" },
        { key: "localizacaoFisica", label: "Localização Fisica" },
        { key: "actions", label: "" },
      ],
    };
  },
  props: {
    prefix: Array,
    codEmpresa: {
      type: Number,
      required: true,
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/documentos-empresa`);
    this.$tipoDocumento = new ResourceService(`/api/tipo-documento`);
  },

  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    triggerFileInput() {
      document.getElementById("documentoInput").click();
    },

    async listDocumentos({ filter = "", page = 1 }) {
      return await this.$tipoDocumento.findAll({ filter, page, limit: 10 });
    },
    adicionarArquivo(event) {
      const files = event.target.files;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataURI = e.target.result;
          const blob = dataURItoBlob(dataURI);

          this.files.push({
            name: file.name,
            file: blob,
            tipoDocumento: {},
            numero: "",
            data: "",
            localizacaoFisica: "",
          });
        };
        reader.readAsDataURL(file);
      }
    },
    async submitData() {
      const validateFile = (fileData, index) => {
        if (!fileData.file || fileData.file.length === 0) {
          this.$notify({
            type: "danger",
            message: `Selecione um arquivo no item ${index + 1}`,
          });
          return false;
        }
        if (!fileData.data) {
          this.$notify({
            type: "danger",
            message: `Data do documento é obrigatória no item ${index + 1}`,
          });
          return false;
        }
        if (!fileData.tipoDocumento || !fileData.tipoDocumento.id) {
          this.$notify({
            type: "danger",
            message: `Tipo de documento é obrigatório no item ${index + 1}`,
          });
          return false;
        }
        if (!/^\d+$/.test(fileData.numero)) {
          this.$notify({
            type: "danger",
            message: `O número do documento deve conter apenas números no item ${index + 1}`,
          });
          return false;
        }
        return true;
      };

      for (let i = 0; i < this.files.length; i++) {
        if (!validateFile(this.files[i], i)) {
          return;
        }
      }

      const formData = new FormData();
      // Percorre os arquivos e inputs para adicionar ao FormData
      this.files.forEach((fileData, index) => {
        formData.append(`files[${index}].file`, fileData.file);
        formData.append(`files[${index}].nome`, fileData.name);
        formData.append(`files[${index}].codEmpresa`, this.codEmpresa);
        formData.append(
          `files[${index}].tipoDocumento`,
          fileData.tipoDocumento.id,
        );
        formData.append(`files[${index}].numeroDocumento`, fileData.numero);
        const dataformatada = moment(fileData.data).format(
          "YYYY-MM-DDTHH:mm:ss",
        );
        formData.append(`files[${index}].dataDocumento`, dataformatada);
        formData.append(
          `files[${index}].localFisico`,
          fileData.localizacaoFisica,
        );
      });

      // Enviar os dados para a API Java
      await API.post("/api/documentos-empresa/multi-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then(() => {
          this.$notify({
            type: "success",
            message: `Documento adicionado com sucesso`,
          });
          this.cancelar();
        })
        .catch((error) => {
          this.$notify({
            type: "danger",
            message: error.toString(),
          });
        });
    },
    removeRow(index) {
      this.files.splice(index, 1);
    },
    cancelar() {
      this.$emit("fechar");
    },
  },
};
</script>
